import { BrowserRouter } from 'react-router-dom';
import { ReactFlowProvider } from '@xyflow/react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

import Routes from '../Routes';
import { AppProvider } from '../../shared';
import { AuthProvider } from '../../shared';
import { UserProvider } from '../../shared';
import { Notifications } from '../Notifications';
import { LanguageContext } from '../../localization';

const rootStyle = getComputedStyle(document.documentElement);

const theme = createTheme({
  palette: {
    primary: {
      main: rootStyle.getPropertyValue('--main').trim(),
      light: rootStyle.getPropertyValue('--button-light').trim(),
      dark: rootStyle.getPropertyValue('--button-main-hover').trim(),
      contrastText: rootStyle.getPropertyValue('--contrast').trim(),
    },
    secondary: {
      main: rootStyle.getPropertyValue('--secondary').trim(),
    },
    background: {
      default: rootStyle.getPropertyValue('--background').trim(),
      paper: rootStyle.getPropertyValue('--contrast').trim(),
    },
    text: {
      primary: rootStyle.getPropertyValue('--main-text').trim(),
      secondary: rootStyle.getPropertyValue('--secondary').trim(),
    },
    error: {
      main: rootStyle.getPropertyValue('--error').trim(),
    },
    success: {
      main: rootStyle.getPropertyValue('--success').trim(),
    },
  },
  typography: {
    fontFamily: `'Roboto', sans-serif`,
    fontSize: 14, // Base font size (matches Tailwind root font size)
    h6: {
      fontWeight: 600,
    },
    subtitle1: {
      fontWeight: 400,
    },
  },
});

(function () {
  const script = document.createElement('script');
  script.defer = true;
  script.src =
    process.env.REACT_APP_WIDGET_URL ||
    'https://dev-cdn.nextlevel.ai/widgets/ai-agents-web-widget_current.js';

  document.head.appendChild(script);
})();

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <LanguageContext>
          <AppProvider>
            <Notifications />
            <CssBaseline />
            <AuthProvider>
              <UserProvider>
                <ReactFlowProvider>
                  <Routes />
                </ReactFlowProvider>
              </UserProvider>
            </AuthProvider>
          </AppProvider>
        </LanguageContext>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
